import { Component, OnInit } from '@angular/core';
import { Payment } from '../payment';
import { PaymentService } from '../payment.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css']
})
export class PaymentListComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  payment = new Payment();  //Po is defined from abobe import po
  payments: Payment[];
  submitted = false;
	message: string;	
	totalrecord:number;
  paymentFilter: any = { pono: '' };
  public DeletePayment = "none"
  public selectedPaymentID;

  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getPayments();
  }

  getPayments() {
    this.spinnerService.show();
    return this.paymentService.getPayment()
               .subscribe(
                payments => {
                  console.log(payments);
                  this.payments = payments
                  this.totalrecord = this.payments.length;
                  this.spinnerService.hide();
                 }
                );
 }

 update(): void {
  this.submitted = true;
  this.paymentService.updatePayment(this.payment)
      .subscribe(() => this.message = "Payment Updated Successfully!");
}

delete(paymentid): void {
  //this.submitted = true;
  this.paymentService.deletePayment(paymentid)
      .subscribe(()=> this.message = "Payment Deleted Successfully!");
  this.getPayments();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}


OpenDeletePayment(PaymentID){
  this.selectedPaymentID = PaymentID
  this.DeletePayment='block'; 
 }

 closeDeletePayment(){
  this.DeletePayment='none'; 
}

OnDeletePayment(paymentid){
  this.paymentService.deletePayment(paymentid)
  .subscribe(()=> this.message = "Payment Deleted Successfully!");
  this.DeletePayment='none'; 
  this.getPayments();  
  }

}
